/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
// core components
import cardImagesStyles from "assets/jss/material-dashboard-react/cardImagesStyles.jsx";
// @material-ui/icons
//core components
import { primaryColor } from "assets/jss/material-dashboard-react.jsx";
import "./landing.css"
import withMobileDialog from "@material-ui/core/withMobileDialog/index";
import { connect } from "react-redux";
import { appConstants } from "../../_constants";
import DefaultLanding from "./roles/default";
import AirportStaffLanding from "./roles/airport_staff";
import AirportManagerLanding from "./roles/airportManager";
import AirlineLanding from "./roles/airline";
import CreditControlLanding from "./roles/creditControl";
import AccountsLanding from "./roles/account";
import AuditLanding from "./roles/audit";
import ExecutiveLanding from "./roles/executive"
import AdminLanding from "./roles/admin"

const styles = theme => ({
    ...cardImagesStyles,
    textWhite: {
        // boxShadow:'0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)',
        borderRadius: '4px',
        "&, & *": {
            color: "#FFF"
        }
    },
    space: {
        padding: '20px',
        color: 'black'
    },
    title: {
        fontWeight: '500',
        fontFamily: "'Montserrat', sans-serif !important",
        color: "black",
        textTransform: "uppercase",
        fontSize: "40px",
        width: "100%"
        // padding:"15px 0"
    },
    cardTitle: {
        fontWeight: '500'
    },
    root: {
        flexGrow: 1,
        width: '100%',
        height: '100vh',
        position: 'absolute',
        bottom: 0,
        background: "url('img/airportabj.jpg')",
        //background:"white",
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
    },
    rootOverlay: {
        flexGrow: 1,
        background: "rgba(0,0,0,.75)",
        width: "100%",
        position: "absolute",
        bottom: 0,
        top: 0,
        height: "100%"
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    center: {
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%'
    },
    center2: {
        paddingTop: ".8rem",
        justifyContent: 'center',
        // alignItems:'center',
        textAlign: 'center',
        width: '100%',
        // marginBottom:"50px"
    },
    card: {
        padding: '1rem 3rem',
        width: "100%"
    },
    checked: {
        color: primaryColor + "!important"
    },
    checkedIcon: {
        width: "20px",
        height: "20px",
        border: "1px solid rgba(0, 0, 0, .54)",
        borderRadius: "3px"
    },
    uncheckedIcon: {
        width: "0px",
        height: "0px",
        padding: "10px",
        border: "1px solid rgba(0, 0, 0, .54)",
        borderRadius: "3px"
    },
    radio: {
        color: primaryColor + "!important"
    },
    radioChecked: {
        width: "20px",
        height: "20px",
        border: "1px solid " + primaryColor,
        borderRadius: "50%"
    },
    radioUnchecked: {
        width: "0px",
        height: "0px",
        padding: "10px",
        border: "1px solid rgba(0, 0, 0, .54)",
        borderRadius: "50%"
    },
    icon: {
        color: '#fff'
    }

});


class Landing extends React.Component {
    state = {
        checked: [],
    };
    handleToggle = value => () => {
        const { checked } = this.state;
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        this.setState({
            checked: newChecked,
        });
    };
    render() {
        const { classes, user } = this.props;
        const props_ = {
            styles: styles,
            user: user,
            classes: classes
        }
        if(user.AppRole === appConstants.ROLES.AIRPORT_STAFF){
            return (<AirportStaffLanding {...props_}/>)
        }
        else if(user.AppRole === appConstants.ROLES.AIRPORT_MANAGER){
            return (<AirportManagerLanding {...props_}/>)
        }
        else if(user.AppRole === appConstants.ROLES.AIRLINE){
            return (<AirlineLanding {...props_}/>)
        } else if (user.AppRole === appConstants.ROLES.CREDIT_CONTROL) {
            return (<CreditControlLanding {...props_} />)
        } else if (user.AppRole === appConstants.ROLES.ACCOUNTS) {
            return (<AccountsLanding {...props_} />)
        } else if (user.AppRole === appConstants.ROLES.AUDIT) {
            return (<AuditLanding {...props_} />)
        }else if (user.AppRole === appConstants.ROLES.EXECUTIVE_USER) {
            return (<ExecutiveLanding {...props_} />)
        }else if (user.AppRole === appConstants.ROLES.ADMIN) {
            return (<AdminLanding {...props_} />)
        }
        else{
            return (<DefaultLanding {...props_} />)
        }
    }
}

Landing.propTypes = {
    classes: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    const { user } = state;
    return {
        user,
    };
}
export default connect(mapStateToProps)(withMobileDialog()(withStyles(styles)(Landing)));



// WEBPACK FOOTER //
// ./src/layouts/Landing/landing.jsx